
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "Spruce Street Harbor",
  "date": "2014-07-08 10",
  "comments": "true",
  "categories": "[\"photo\", \"summer\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2014-07-08",
  "tags": [
    "photo",
    "summer"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":[{"type":"a","props":{"href":"http://www.delawareriverwaterfront.com/places/spruce-street-harbor-park"},"children":["Spruce Street Harbor Park"]}," is a summer pop-up-type installation on the Delaware River filled with hammocks, sand, and over-sized games (I spotted large chess pieces and tic-tac-toe). Garces has some hand in the food and drink served out of shipping containers a la ",{"type":"a","props":{"href":"http://karlshouler.com/blog/2013/08/08/popup-beer-garden/"},"children":["last summer's PHS garden at Spruce and Broad"]},". They've also included a serious array of lights in the water and trees that constantly rotate hue."]},"\n",{"type":"p","props":{},"children":["For the photo nerds, this was shot at 1/8s, f/4.0, ISO2500.\n",{"type":"img","props":{"src":"/static/images/posts/20140707-DSCF4971.jpg","alt":"sshp"}}]},"\n",{"type":"p","props":{},"children":["1/125s, f/2.0, ISO2500\n",{"type":"img","props":{"src":"/static/images/posts/20140628-DSCF4829.jpg","alt":"funnelcake"}}]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
